import { render } from "./ApiDLR.vue?vue&type=template&id=09dfd874"
import script from "./ApiDLR.vue?vue&type=script&lang=js"
export * from "./ApiDLR.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__